import { approvalLabel, approvalTone, approvalTooltip, TaskApprovalStatus, UpcomingWork } from '@jms/model';
import { defineStatusTag } from '../../shared/define.status.tag';

/**
 * The approval pill on a task-grain row — for the CARD and KANBAN renderers only.
 *
 * The board TABLE cannot reach this: `presentation.tags` is read by those two renderers, while
 * `wb-value` picks its renderer from field metadata alone. The table's pill comes from the badge
 * options on `approvalStatus` in `upcoming.work.metadata.ts` (API side). Both read the labels and
 * tones of `task.approval.policy.ts`, so one status renders the same on every board.
 */
export const upcomingWorkApprovalTag = defineStatusTag<TaskApprovalStatus, UpcomingWork>(
  byStatus(approvalTone),
  {
    labels: byStatus(approvalLabel),
    tooltips: byStatus(approvalTooltip),
  },
);

/** Every standing mapped through one policy reader, so the tag's maps cannot miss a member. */
function byStatus<T>(read: (status: TaskApprovalStatus) => T): Record<TaskApprovalStatus, T> {

  return Object.fromEntries(Object.values(TaskApprovalStatus).map(status => [status, read(status)])) as Record<TaskApprovalStatus, T>;
}
